/** The Inbox rows (decisions joined with the hub's asks and cards), shared by list and inspector. */
import { useMemo } from 'react'
import { itemFreshness } from '../../lib/inbox-freshness.js'
import { buildInboxRows } from '../../lib/now-inbox.js'
import { useInbox, useLandings, useMachines, useProjects, useRuns } from '../../lib/queries.js'
import { useDecisions } from '../decision/useDecisions.js'
import { useLocked } from '../lock/ContentLock.js'

export function useInboxRows() {
  const inbox = useInbox()
  const decisions = useDecisions()
  const runs = useRuns()
  const projects = useProjects()
  const machines = useMachines()
  const landings = useLandings()
  const locked = useLocked()
  const built = useMemo(
    () =>
      buildInboxRows({
        decisions: decisions.data ?? [],
        items: inbox.data ?? [],
        runs: runs.data ?? [],
        projects: projects.data ?? [],
        machines: machines.data ?? [],
        now: Date.now(),
        ...(decisions.store ? { projectOf: decisions.store.projectOf } : {}),
        // inbox-detail: stall / landing items are re-checked against the newest reports
        freshness: (i) =>
          itemFreshness(i, {
            machines: machines.data ?? [],
            landings: landings.data ?? [],
            runs: runs.data ?? [],
            now: Date.now(),
            locked,
          }),
      }),
    [
      decisions.data,
      decisions.store,
      inbox.data,
      runs.data,
      projects.data,
      machines.data,
      landings.data,
      locked,
    ],
  )
  return {
    ...built,
    loading: inbox.isPending || (decisions.isPending && !!decisions.store),
    decisions,
    inbox,
  }
}
